var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 12.6667C6.71127 12.6667 5.61127 12.2112 4.70016 11.3C3.78905 10.3889 3.3335 9.28893 3.3335 8.00004C3.3335 6.71115 3.78905 5.61115 4.70016 4.70004C5.61127 3.78893 6.71127 3.33337 8.00016 3.33337C9.28905 3.33337 10.3891 3.78893 11.3002 4.70004C12.2113 5.61115 12.6668 6.71115 12.6668 8.00004C12.6668 9.28893 12.2113 10.3889 11.3002 11.3C10.3891 12.2112 9.28905 12.6667 8.00016 12.6667ZM8.00016 11.3334C8.92239 11.3334 9.70861 11.0083 10.3588 10.358C11.0086 9.70826 11.3335 8.92226 11.3335 8.00004C11.3335 7.07782 11.0086 6.2916 10.3588 5.64137C9.70861 4.9916 8.92239 4.66671 8.00016 4.66671C7.07794 4.66671 6.29194 4.9916 5.64216 5.64137C4.99194 6.2916 4.66683 7.07782 4.66683 8.00004C4.66683 8.92226 4.99194 9.70826 5.64216 10.358C6.29194 11.0083 7.07794 11.3334 8.00016 11.3334Z",
    fill: "#959596"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.27a4abf408f71515e9fc69addde4873a.svg";
export { ForwardRef as ReactComponent };